{
	"content": {
		"declarationDetailsSection": {
			"title": "Erklärungsdetails",
			"description": "Für die Erstellung der Erklärung werden der Name, die Adresse und das Land des Erklärungshalters benötigt. Die Angaben können nachträglich nicht geändert werden.",
			"customerLabel": "Kundenkonto"
		},
		"provideDeclarationsDetailsSection": {
			"title": "Erklärungsdetails angeben",
			"alertDescription": "Die von Ihnen bereitgestellten Informationen werden dauerhaft in der Erklärung gespeichert und können nachträglich nicht geändert werden.",
			"projectLabel": "Projektreferenz",
			"companyNameLabel": "Firmenname",
			"streetLabel": "Straße",
			"zipCodeLabel": "Postleitzahl",
			"cityLabel": "Stadt",
			"countryLabel": "Land"
		}
	},
	"summary": {
		"title": "Zusammenfassung",
		"declarationTypeTitle": "Erklärungstyp",
		"customerProjectTitle": "Kundenprojekt",
		"internalProjectOrProductTitle": "Internes Projekt / Produkt",
		"projectReferenceTitle": "Projektreferenz",
		"materialHeaderTitle": "Material",
		"quantityHeaderTitle": "Menge ({{unit}})",
		"totalTransferableCarbonReductionsTitle": "Zuordenbare CO₂-Reduktionen ({{unit}})",
		"nonTransferableCarbonReductionTitle": "Nicht zuordenbare CO₂-Reduktion ({{unit}})"
	},
	"errorMessages": {
		"projectRequired": "Projektreferenz ist erforderlich",
		"companyNameRequired": "Firmenname ist erforderlich",
		"streetRequired": "Straße ist erforderlich",
		"zipCodeRequired": "Postleitzahl ist erforderlich",
		"cityRequired": "Stadt ist erforderlich",
		"countryRequired": "Land ist erforderlich",
		"customerRequired": "Kunde ist erforderlich"
	},
	"reviewDeclarationDetailsModal": {
		"title": "Erklärungszusammenfassung überprüfen",
		"description": "Bitte überprüfen Sie die von Ihnen eingegebenen Daten auf Fehler.",
		"alertDescription": "Die von Ihnen bereitgestellten Informationen werden dauerhaft in der Erklärung gespeichert und können nachträglich nicht geändert werden.",
		"typeSectionTitle": "1. Typ",
		"declarationTypeLabel": "Erklärungstyp",
		"customerProjectTitle": "Kundenprojekt",
		"internalProjectOrProductTitle": "Internes Projekt / Produkt",
		"projectReferenceLabel": "Projektreferenz",
		"materialSectionTitle": "2. Material",
		"materialHeaderTitle": "Material",
		"quantityHeaderTitle": "Menge ({{unit}})",
		"totalCarbonReductionsLabel": "Gesamte CO₂-Reduktionen ({{unit}})",
		"declarationSectionTitle": "3. Erklärung",
		"companyNameLabel": "Firmenname",
		"streetLabel": "Straße",
		"zipCodeLabel": "Postleitzahl",
		"cityLabel": "Stadt",
		"countryLabel": "Land",
		"backTitle": "Zurück",
		"submitTitle": "Ja, alles ist korrekt"
	},
	"submitTitle": "Erklärung erstellen",
	"backTitle": "Zurück"
}
